import { render } from "./ManageProjectsView.vue?vue&type=template&id=4b4230b8&scoped=true"
import script from "./ManageProjectsView.vue?vue&type=script&lang=js"
export * from "./ManageProjectsView.vue?vue&type=script&lang=js"

import "./ManageProjectsView.vue?vue&type=style&index=0&id=4b4230b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4230b8"]])

export default __exports__